/**
 * Typical Mufin API success envelope: code "0000" and/or success !== false.
 */
export function isApiSuccessEnvelope(payload) {
  if (!payload || typeof payload !== "object") return false;
  if (payload.success === false) return false;
  if (payload.code != null && payload.code !== "0000") return false;
  return true;
}

/**
 * Readable message from typical Mufin API envelopes: { code, msg, message, data }.
 */
export function getApiEnvelopeMessage(payload, fallback) {
  if (payload == null || typeof payload !== "object") return fallback;
  const msg =
    payload.msg ||
    payload.message ||
    payload.errorMessage ||
    (typeof payload.error === "string" ? payload.error : null);
  return msg || fallback;
}
